module.exports = __webpack_public_path__ + "img/sb.9d973467.svg";